import axios from "axios";
import { Chart } from "frappe-charts/dist/frappe-charts.min.esm";

const script = document.querySelector("head").baseURI;
const isMe = script.includes("me");

const input = document.querySelector("#name");
const queryName = input ? input.value : "";

const input2 = document.querySelector("#day");
const queryDay = input2 ? input2.value - 1 : "";

let dailyApplicationGraph = document.querySelector(
    "#daily_application_graph .chart"
);

if (dailyApplicationGraph) {
    axios.get("/graph?graph=daily_income_graph").then(function (response) {
        let data = response.data;
        let chart = new Chart(dailyApplicationGraph, {
            data: data,
            type: "bar", // or 'bar', 'line', 'pie', 'percentage'
            height: 180,
            colors: ["purple", "#ffa3ef", "light-blue"],
            axisOptions: {
                xAxisMode: "tick",
                xIsSeries: true,
            },
            truncateLegends: true,
            barOptions: {
                spaceRatio: 0.5,
            },
            tooltipOptions: {
                formatTooltipX: (d) => (d + "").toUpperCase(),
                formatTooltipY: (d) =>
                    d.toLocaleString("tr-TR", { minimumFractionDigits: 2 }) +
                    " TL",
            },
        });
    });
}

let lastSixMonthsIncomeGraph = document.querySelector(
    "#last_six_months_income_graph .chart"
);

if (lastSixMonthsIncomeGraph) {
    axios
        .get("/graph?graph=last_six_months_income_graph")
        .then(function (response) {
            let data = response.data;
            let chart = new Chart(lastSixMonthsIncomeGraph, {
                data: data,
                type: "axis-mixed", // or 'bar', 'line', 'pie', 'percentage'
                height: 180,
                colors: ["light-blue"],
                axisOptions: {
                    xAxisMode: "tick",
                    xIsSeries: true,
                },
                truncateLegends: true,
                barOptions: {
                    spaceRatio: 0.5,
                },
                lineOptions: {
                    dotSize: 3, // default: 4
                },
                tooltipOptions: {
                    formatTooltipX: (d) => (d + "").toUpperCase(),
                    formatTooltipY: (d) => {
                        return (
                            d.toLocaleString("tr-TR", {
                                minimumFractionDigits: 2,
                            }) + " TL"
                        );
                    },
                },
            });
        });
}

let monthlySatisElemaniIncomeGraph = document.querySelector(
    "#monthly_satiselemani_income_graph .chart"
);

if (monthlySatisElemaniIncomeGraph) {
    axios
        .get(
            isMe
                ? "/me/graph/monthly-employee/" + queryName
                : "/graph/monthly-employee/" + queryName
        )
        .then(function (response) {
            let data = response.data;
            let chart = new Chart(monthlySatisElemaniIncomeGraph, {
                data: data,
                type: "axis-mixed", // or 'bar', 'line', 'pie', 'percentage'
                height: 180,
                colors: ["orange"],
                axisOptions: {
                    xAxisMode: "tick",
                    xIsSeries: true,
                },
                truncateLegends: true,
                barOptions: {
                    spaceRatio: 0.5,
                },
                lineOptions: {
                    dotSize: 3, // default: 4
                },
                tooltipOptions: {
                    formatTooltipX: (d) => (d + "").toUpperCase(),
                    formatTooltipY: (d) => {
                        return (
                            d.toLocaleString("tr-TR", {
                                minimumFractionDigits: 2,
                            }) + " TL"
                        );
                    },
                },
            });
        });
}

let brandPieChart = document.querySelector("#brand_pie_chart .chart");
if (brandPieChart) {
    axios
        .get(
            isMe
                ? "/me/graph/brand-pie-chart/" + queryName + "/" + queryDay
                : "/graph/brand-pie-chart/" + queryName + "/" + queryDay
        )
        .then(function (response) {
            let data = response.data;
            let chart = new Chart(brandPieChart, {
                data: data,
                type: "pie", // or 'bar', 'line', 'pie', 'percentage'
                //colors: "purple",
                height: 600,
                isNavigable: 0,
                valuesOverPoints: 1,
                barOptions: {
                    stacked: 0,
                },
                lineOptions: {
                    dotSize: 4,
                    hideLine: 0,
                    hideDots: 0,
                    heatline: 0,
                    areaFill: 0,
                },
                axisOptions: {
                    yAxisMode: "span",
                    xAxisMode: "span",
                    xIsSeries: 0,
                },
                maxLegendPoints: 9,
                maxSlices: 12,
                barOptions: { height: 20, depth: 2 },
                discreteDomains: 1,
                truncateLegends: true,
            });
        });
}

let valuePieChart = document.querySelector("#value_pie_chart .chart");

if (valuePieChart) {
    axios
        .get(
            isMe
                ? "/me/graph/value-pie-chart/" + queryName + "/" + queryDay
                : "/graph/value-pie-chart/" + queryName + "/" + queryDay
        )
        .then(function (response) {
            let data = response.data;
            let chart = new Chart(valuePieChart, {
                data: data,
                type: "pie", // or 'bar', 'line', 'pie', 'percentage'
                //colors: "purple",
                height: 600,
                isNavigable: 0,
                valuesOverPoints: 1,
                barOptions: {
                    stacked: 0,
                },
                lineOptions: {
                    dotSize: 4,
                    hideLine: 0,
                    hideDots: 0,
                    heatline: 0,
                    areaFill: 0,
                },
                axisOptions: {
                    yAxisMode: "span",
                    xAxisMode: "span",
                    xIsSeries: 0,
                },
                maxLegendPoints: 9,
                maxSlices: 12,
                barOptions: { height: 20, depth: 2 },
                discreteDomains: 1,
                truncateLegends: true,
            });
        });
}

const monthlyCariSalesGraph = document.querySelector(
    "#monthly_cari_sales_graph .chart"
);

if (monthlyCariSalesGraph) {
    const queryName = document
        .querySelector("#monthly_cari_sales_graph")
        .getAttribute("data-query");
    axios.get("/graph/monthly-cari/" + queryName).then(function (response) {
        let data = response.data;
        const chart = new Chart(monthlyCariSalesGraph, {
            data: data,
            type: "axis-mixed", // or 'bar', 'line', 'pie', 'percentage'
            height: 180,
            colors: ["orange"],
            axisOptions: {
                xAxisMode: "tick",
                xIsSeries: true,
            },
            truncateLegends: true,
            barOptions: {
                spaceRatio: 0.5,
            },
            lineOptions: {
                dotSize: 3, // default: 4
            },
            tooltipOptions: {
                formatTooltipX: (d) => (d + "").toUpperCase(),
                formatTooltipY: (d) => {
                    return d
                        ? d.toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                          }) + " TL"
                        : "";
                },
            },
        });
    });
}

let cariPieChart = document.querySelector("#cari_category_pie .chart");
if (cariPieChart) {
    const queryName = document
        .querySelector("#cari_category_pie")
        .getAttribute("data-query");
    axios
        .get("/graph/cari-category-chart/" + queryName + "/" + queryDay)
        .then(function (response) {
            let data = response.data;
            let chart = new Chart(cariPieChart, {
                data: data,
                type: "pie", // or 'bar', 'line', 'pie', 'percentage'
                //colors: "purple",
                height: 600,
                isNavigable: 0,
                valuesOverPoints: 1,
                barOptions: {
                    stacked: 0,
                },
                lineOptions: {
                    dotSize: 4,
                    hideLine: 0,
                    hideDots: 0,
                    heatline: 0,
                    areaFill: 0,
                },
                axisOptions: {
                    yAxisMode: "span",
                    xAxisMode: "span",
                    xIsSeries: 0,
                },
                maxLegendPoints: 9,
                maxSlices: 12,
                barOptions: { height: 20, depth: 2 },
                discreteDomains: 1,
                truncateLegends: true,
            });
        });
}

let cariBrandPieChart = document.querySelector("#cari_brand_pie .chart");
if (cariBrandPieChart) {
    const queryName = document
        .querySelector("#cari_category_pie")
        .getAttribute("data-query");
    axios
        .get("/graph/cari-brand-chart/" + queryName + "/" + queryDay)
        .then(function (response) {
            console.log(response);
            let data = response.data;
            let chart = new Chart(cariBrandPieChart, {
                data: data,
                type: "pie", // or 'bar', 'line', 'pie', 'percentage'
                //colors: "purple",
                height: 600,
                isNavigable: 0,
                valuesOverPoints: 1,
                barOptions: {
                    stacked: 0,
                },
                lineOptions: {
                    dotSize: 4,
                    hideLine: 0,
                    hideDots: 0,
                    heatline: 0,
                    areaFill: 0,
                },
                axisOptions: {
                    yAxisMode: "span",
                    xAxisMode: "span",
                    xIsSeries: 0,
                },
                maxLegendPoints: 9,
                maxSlices: 12,
                barOptions: { height: 20, depth: 2 },
                discreteDomains: 1,
                truncateLegends: true,
            });
        });
}

var productFamilySalesBarChart = document.querySelector("#productFamilySalesBarChart .chart");
if(productFamilySalesBarChart) {
    const queryUserName = document.querySelector("#name").value;

    axios.get("/graph/product-family-sales-bar-chart/" + queryUserName + "/" + queryDay).then(function(response) {
        new Chart(productFamilySalesBarChart, {
            data: response.data,
            type: "bar",
            height: 180,
            colors: ["orange"],
            axisOptions: {
                xAxisMode: "tick",
                xIsSeries: true
            },
            truncateLegends: true,
            barOptions: {
                spaceRatio: 0.5
            },
            tooltipOptions: {
                formatTooltipX: d => (d + "").toUpperCase(),
                formatTooltipY: d => {
                    return d ? d.toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " TL" : "";
                }
            }
        });
    });
}
